import { Component, OnInit, inject } from '@angular/core';
import { ResponsiveService } from '@app/services/responsive.service';

@Component({
  selector: 'app-new-deal-standard-quote-page',
  template: `
  @if(responsiveService.isMobileSignal()){
    <app-new-deal-standard-quote-mobile />
  } @else {
    <app-new-deal-standard-quote-desktop />
  }
  `
})
export class NewDealStandardQuotePageComponent implements OnInit {
  public responsiveService = inject(ResponsiveService);

  ngOnInit(): void {
    this.responsiveService.onListen();
  }
}
